import models from './models'
import routes from './routes'

export default {
  name: 'Settings',

  setup () {
    return {
      routes
    }
  },

  models () {
    return {
      'stores': models.Store,
      'zones': models.Zone,
      'territories': models.Territory,
      'general_settings': models.GeneralSettings,
      'contact_address': models.ContactAddress,
      'settings': models.Settings,
      'taxRates': models.TaxRate,
      'taxGroups': models.TaxGroup,
      'vat': models.VAT,
      'shipping': models.Shipping,
      'paymentMethods': models.PaymentMethods,
      'abilities': models.Abilities,
      'country': models.Country,
      'state_machine': models.StateMachine,
      'notification': models.Notification,
      'language': models.Language
    }
  }
}
